/**
 * Shared data-freshness helper for the business cockpit family (#1008).
 *
 * The cockpit, SKU-economics, and risk-workbench pages all mark their
 * `generatedAt` timestamp as stale past the same threshold; this is the
 * single source for that rule so the three pages cannot drift apart.
 */

/** `generatedAt` older than this renders the staleness marker. */
export const STALE_AFTER_MS = 10 * 60 * 1000;

export function isStale(generatedAt: string): boolean {
  const ageMs = Date.now() - Date.parse(generatedAt);
  return Number.isFinite(ageMs) && ageMs > STALE_AFTER_MS;
}
